angular.module 'zc.core'

.filter 'hourOfDay', ($filter, $translate) ->
  (hour) ->
    date = moment().hour(hour).toDate()
    $filter('date')(date, $translate.instant('sharedModules.dateTimeFormats.filters.hourOfDay.format'))



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/hour_of_day.js.coffee